var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar-image"},[_c('v-avatar',{class:{
      borderBoxed: _vm.hasBorder,
      'avatar-image__contain': _vm.contain,
    },attrs:{"size":_vm.size || 200,"tile":_vm.contain}},[_c('v-image',{attrs:{"alt":"Avatar","src":_vm.picture,"waitLoading":_vm.waitLoading}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }